import { Button } from "@mui/material";
import { ActionsMenu, Flex } from "@zfp-akademie-a-s/zfp-design";
import { ChevronDownIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { useListCurrentSolutionAssetOptions } from "Infrastructure/ApiZfp/AnalyzerApi";
import type { CurrentSolutionAssetOption } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { useContext, useState } from "react";

type Props = {
  readonly onAssetPick: (asset: CurrentSolutionAssetOption) => void;
};

export const CurrentSolutionPrefillAsset = ({ onAssetPick }: Props) => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const { data: assetOptions } = useListCurrentSolutionAssetOptions(analysisId, versionId);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => setAnchorEl(null);

  const getAssetOptionLabel = (asset: CurrentSolutionAssetOption) => {
    const labelParts: string[] = [
      t(Resources.AnalysisDetail.GoalsFulfillment.InvestmentToolTypeOptions[asset.investmentToolType]),
      asset.name,
    ];

    const amountValue = asset.amount?.value;
    const regularAmountValue = asset.regularAmount?.value;

    if (amountValue !== undefined && amountValue !== null) {
      labelParts.push(`${formatCurrency(amountValue, asset.amount?.currencyCode)}`);
    } else if (regularAmountValue !== undefined && regularAmountValue !== null) {
      labelParts.push(`${formatCurrency(regularAmountValue, asset.regularAmount?.currencyCode)}/${t(Resources.Common.Month)}`);
    }

    return labelParts.filter(Boolean).join(" - ");
  };

  return (
    <>
      <Flex justifyContent="flex-end">
        <Button
          variant="text"
          onClick={openMenu}
          endIcon={
            <ChevronDownIcon
              fontSize="small"
              sx={{
                color: "primary.main",
                transform: isMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          }
        >
          {t(Resources.AnalysisDetail.GoalsFulfillment.LoadCurrentSolution)}
        </Button>
      </Flex>
      <ActionsMenu
        anchorEl={anchorEl}
        onClose={closeMenu}
        items={(assetOptions?.items ?? []).map((asset) => ({ label: getAssetOptionLabel(asset), onClick: () => onAssetPick(asset) }))}
      />
    </>
  );
};
